import styled from 'styled-components';

export const BGWrap = styled.div`
  width: 100%;
  padding-top: ${({ width, height }) => `${(height / width) * 100}%`};
  border-top: none;
  border-bottom: none;
  box-sizing: border-box;
  background: url(${({ imgUrl }) => imgUrl}) center center no-repeat;
  background-size: cover;
  position: relative;
`;
